<p-toast></p-toast>
<!-- <p-progressBar mode="indeterminate" *ngIf="isLoading"></p-progressBar> -->

<div class="col-12">
  <div class="card" reflow="true">
    <h5>{{'FARMERS_DETAILS' | translate}}</h5>
    <form [formGroup]="farmersDetailsForm">


      <div class="p-fluid p-formgrid grid">
        <div class="field col-12 md:col-4">
          <label htmlFor="farmerName">{{'FARMER_NAME' | translate}}</label>
          <input formControlName="farmersName" pInputText id="farmerName" type="text" [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && farmersFormControls.farmersName.errors }" />
          <div *ngIf="isSubmitted && farmersFormControls.farmersName.errors" class="invalid-feedback">
            <div *ngIf="farmersFormControls.farmersName.errors.required">{{'FARMER_NAME_IS_REQUIRED'}}</div>
          </div>
        </div>

        <div class="field col-12 md:col-4">
          <label htmlFor="block">{{'FARMER_PHOTO' | translate}}</label>
          <div class="flex">


            <p-fileUpload accept=".jpeg,.pdf,.jpg" #farmerPhotoFileUpload [customUpload]="true" (uploadHandler)="onUpload($event, 'farmersPhotoPath', farmerPhotoFileUpload)" name="myfile[]" mode="basic" [maxFileSize]="5000000" chooseLabel="{{'BROWSE' | translate}}" [auto]="true" >
            </p-fileUpload>
            <p-image *ngIf="farmersFormControls.farmersPhotoPath.value" [src]="farmersFormControls.farmersPhotoPath.value" alt="Image" width="60" class="ml-2 p-button-rounded p-button-success" iconPos="left"></p-image>

            <!-- <div class="image-background ml-2">

              <img [src] ="farmersFormControls.farmersPhotoPath.value" alt="farmer photo" *ngIf="farmersFormControls.farmersPhotoPath.value"  class="ml-2 p-button-rounded p-button-success" iconPos="left">
            </div>

            <button *ngIf="farmersFormControls.farmersPhotoPath.value" pButton type="button" icon="pi pi-check" class="ml-2 p-button-rounded p-button-success" iconPos="left"></button> -->
          </div>
          <div *ngIf="isSubmitted && farmersFormControls.farmersPhotoPath.errors" class="invalid-feedback">
            <div *ngIf="farmersFormControls.farmersPhotoPath.errors.required">{{'FARMERS_PHOTO_IS_REQUIRED' | translate}}</div>
          </div>

        </div>

        <div class="field col-12 md:col-4">
          <label htmlFor="gender">{{'GENDER' | translate}}</label>
          <div class="formgroup-inline">
            <div class="field">
              <div class="field-radiobutton mb-0">
                <p-radioButton formControlName="gender" value="M" id="IsSubsidyAvailabeNo" [(ngModel)]="genderType"></p-radioButton>
                <label for="IsSubsidyAvailabeNo">{{'MALE' | translate}}</label>
              </div>
            </div>
            <div class="field">
              <div class="field-radiobutton mb-0">
                <p-radioButton formControlName="gender" value="F" id="IsSubsidyAvailabeNo" [(ngModel)]="genderType"></p-radioButton>
                <label for="IsSubsidyAvailabeNo">{{'FEMALE' | translate}}</label>
              </div>
            </div>
            <div class="field mr-0">
              <div class="field-radiobutton mb-0">
                <p-radioButton formControlName="gender" value="T" id="IsSubsidyAvailabeNo" [(ngModel)]="genderType"></p-radioButton>
                <label for="IsSubsidyAvailabeNo">{{'TRANSGENDER' | translate}}</label>
              </div>
            </div>
          </div>
          <!-- <input pInputText id="availableOnLand" type="text" /> -->
        </div>

        <!-- <div class="field col-12 md:col-4">
          <label htmlFor="block">Block</label>
          <input  pInputText id="block" type="text" />
        </div> -->
        <div class="field col-12 md:col-4">
          <label htmlFor="fatherName">{{'FATHERS_NAME' | translate}}</label>
          <input formControlName="fathersName" pInputText id="fatherName" type="text"  [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && farmersFormControls.fathersName.errors }" />

          <div *ngIf="isSubmitted && farmersFormControls.fathersName.errors" class="invalid-feedback">
            <div *ngIf="farmersFormControls.fathersName.errors.required">{{'FATHERS_NAME_IS_REQUIRED' | translate}}</div>
          </div>

          <!-- <p-dropdown [options]="dropdownItems" optionLabel="name" [(ngModel)]="selectedState"></p-dropdown> -->
        </div>
        <div class="field col-12 md:col-4">
          <label htmlFor="motherName">{{'MOTHER_NAME' | translate}}</label>
          <input formControlName="mothersName" pInputText id="motherName" type="text" [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && farmersFormControls.mothersName.errors }" />

          <div *ngIf="isSubmitted && farmersFormControls.mothersName.errors" class="invalid-feedback">
            <div *ngIf="farmersFormControls.mothersName.errors.required">{{'MOTHERS_NAME_IS_REQUIRED' | translate}}</div>
          </div>
        </div>
        <div class="field col-12 md:col-4">
          <label htmlFor="block">{{'DATE_OF_BIRTH' | translate}}</label>
          <p-calendar [maxDate]="todayDate" [showIcon]="true" [showButtonBar]="true"  dateFormat="dd-mm-yy" formControlName="dob" [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && farmersFormControls.dob.errors }"></p-calendar>
          <div *ngIf="isSubmitted && farmersFormControls.dob.errors" class="invalid-feedback">
            <div *ngIf="farmersFormControls.dob.errors.required">{{'DATE_OF_BIRTH_IS_REQUIRED' | translate}}</div>
          </div>

          <!-- <input formControlName="dob" slotChar="mm/dd/yyyy" mask="99/99/9999" pInputText id="block" type="text" /> -->
        </div>
        <div class="field col-12 md:col-4">
          <label htmlFor="fatherName">{{'EMAIL_ID' | translate}}</label>
          <input formControlName="emailId" pInputText id="fatherName" type="text" [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && farmersFormControls.emailId.errors }" />

          <div *ngIf="isSubmitted && farmersFormControls.emailId.errors" class="invalid-feedback">
            <div *ngIf="farmersFormControls.emailId.errors.required">{{'EMAIL_ID_IS_REQUIRED' | translate}}</div>
            <div *ngIf="farmersFormControls.emailId.errors.email">{{'EMAIL_IS_INVALID' | translate}}</div>
          </div>
        </div>
        <div class="field col-12 md:col-4">
          <label htmlFor="fatherName">{{'MOBILE' | translate}}</label>
          <!-- <input maxlength="10" pattern="^[0-9]{10}$" pKeyFilter="int"formControlName="mobileNo" pInputText id="fatherName" type="text" [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && farmersFormControls.mobileNo.errors }"/> -->
          <div>
            <span>{{farmersDetailsForm.controls.mobileNo.value}}</span>
          </div>

          <div *ngIf="isSubmitted && farmersFormControls.mobileNo.errors" class="invalid-feedback">
            <div *ngIf="farmersFormControls.mobileNo.errors.required">{{'MOBILE_NO_IS_REQUIRED' | translate}}</div>

            <div *ngIf="farmersFormControls.mobileNo.errors.minlength">{{'MOBILE_NO_SHOULD_BE_OF_10_DIGITS' | translate}}</div>
            <div *ngIf="farmersFormControls.mobileNo.errors.maxlength">{{'MOBILE_NO_SHOULD_BE_OF_10_DIGITS' | translate}}</div>
            <div *ngIf="farmersFormControls.mobileNo.errors.pattern">{{'MBILE_NO_SHOULD_CONTAIN' | translate}}</div>

          </div>
        </div>

        <div class="field col-12 md:col-4">
          <label htmlFor="block">{{'CASTE' | translate}}</label>
          <div class="formgroup-inline">
            <div class="field">
              <div class="field-radiobutton mb-0">
                <p-radioButton formControlName="caste" value="1" id="IsSubsidyAvailabeYes"></p-radioButton>
                <label for="IsSubsidyAvailabeYes">{{'GEN' | translate}}</label>
              </div>
            </div>
            <div class="field">
              <div class="field-radiobutton mb-0">
                <p-radioButton formControlName="caste" value="2" id="IsSubsidyAvailabeYes"></p-radioButton>
                <label for="IsSubsidyAvailabeYes">{{'BC' | translate}}</label>
              </div>
            </div>
            <div class="field">
              <div class="field-radiobutton mb-0">
                <p-radioButton formControlName="caste" value="3" id="IsSubsidyAvailabeNo"></p-radioButton>
                <label for="IsSubsidyAvailabeNo">{{'SC' | translate}}</label>
              </div>
            </div>
            <!-- <div class="field">
              <div class="field-radiobutton mb-0">
                <p-radioButton formControlName="caste" value="2" id="IsSubsidyAvailabeNo"></p-radioButton>
                <label for="IsSubsidyAvailabeNo">OBC</label>
              </div>
            </div> -->
          </div>

          <!-- <input pInputText id="block" type="text" /> -->
        </div>
        <!-- <div class="field col-12 md:col-4">
          <label htmlFor="fatherName">Aadhar Copy</label>
          <input pInputText id="fatherName" type="text" />
        </div> -->

        <!-- <div class="field col-12 md:col-4">
          <label htmlFor="block">Caste</label>
          <input pInputText id="block" type="text" />
        </div> -->
        <div class="field col-12 md:col-4">
          <label htmlFor="fatherName">{{'ADDRESS' | translate}}</label>
          <input formControlName="address" pInputText id="fatherName" type="text" [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && farmersFormControls.address.errors }"/>

          <div *ngIf="isSubmitted && farmersFormControls.address.errors" class="invalid-feedback">
            <div *ngIf="farmersFormControls.address.errors.required">{{'ADDRESS_IS_REQUIRED'}}</div>
          </div>
        </div>
        <div class="field col-12 md:col-4">
          <label htmlFor="villageCode">{{'VILLAGE' | translate}}</label>
          <p-autoComplete formControlName="village" [(ngModel)]="selectedVillage"  placeholder="Search" id="dd" [dropdown]="true" [multiple]="false"
            [suggestions]="filteredVillage" (completeMethod)="filterVillage($event)" field="Name" value="Code" [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && farmersFormControls.village.errors }"></p-autoComplete>

            <div *ngIf="isSubmitted && farmersFormControls.village.errors" class="invalid-feedback">
              <div *ngIf="farmersFormControls.village.errors.required">{{'VILLAGE_NAME_IS_REQUIRED' | translate}}</div>
            </div>

          <!-- <input formControlName="village" pInputText id="villageCode" type="text" /> -->
        </div>

        <div class="field col-12 md:col-4">
          <label htmlFor="pinCode">{{'PINCODE' | translate}}</label>
          <input maxlength="6" pattern="^[0-9]{6}$" pKeyFilter="int" formControlName="pincode" pInputText id="pinCode" type="text"
          [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && farmersFormControls.pincode.errors }" />

          <div *ngIf="isSubmitted && farmersFormControls.pincode.errors" class="invalid-feedback">
            <div *ngIf="farmersFormControls.pincode.errors.required">{{'PINCODE_IS_REQUIRED' | translate}}</div>
          </div>
        </div>

        <div class="field col-12 md:col-4">
          <label htmlFor="mfmbNo">{{'MFMB_NO' | translate}}</label>
          <input maxlength="8" pattern="^[0-9]{8}$" pKeyFilter="int"  formControlName="mfmbNo" pInputText id="block" type="text"
          [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && farmersFormControls.mfmbNo.errors }" />
          <div *ngIf="isSubmitted && farmersFormControls.mfmbNo.errors" class="invalid-feedback">
            <div *ngIf="farmersFormControls.mfmbNo.errors.required">{{'MFMB_NO_REQUIRED'}}</div>
            <div *ngIf="farmersFormControls.mfmbNo.errors.minlength">{{'MFMB_NO_REQUIRED_NO_IS_SHOULD_BE_OF_12_DIGITS' | translate}}</div>
            <div *ngIf="farmersFormControls.mfmbNo.errors.maxlength">{{'MFMB_NO_REQUIRED_NO_IS_SHOULD_BE_OF_12_DIGITS' | translate}}</div>
            <div *ngIf="farmersFormControls.mfmbNo.errors.pattern">{{'MFMB_NO_REQUIRED_NO_SHOULD_CONTAIN_ONLY_DIGITS' | translate}}</div>
          </div>
        </div>



        <!-- <div class="field col-12 md:col-4">
          <label htmlFor="fatherName">ID Proof Type</label>
          <input pInputText id="fatherName" type="text" />
        </div> -->


        <!-- <div class="field col-12 md:col-4">
          <label htmlFor="fatherName">ID Proof</label>
          <input formControlName="idProof" pInputText id="fatherName" type="text" [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && farmersFormControls.idProof.errors }" />

          <div *ngIf="isSubmitted && farmersFormControls.idProof.errors" class="invalid-feedback">
            <div *ngIf="farmersFormControls.idProof.errors.required">ID Proof is required</div>
          </div>
        </div> -->

        <div class="field col-12 md:col-4">
          <label htmlFor="block">{{'AADHAR_NUMBER' | translate}}</label>
          <input maxlength="12" pattern="^[0-9]{12}$" pKeyFilter="int"  formControlName="aadharNo" pInputText id="block" type="text"
          [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && farmersFormControls.aadharNo.errors }" />

          <div *ngIf="isSubmitted && farmersFormControls.aadharNo.errors" class="invalid-feedback">
            <div *ngIf="farmersFormControls.aadharNo.errors.required">{{'AADHAR_NO_IS_REQUIRED' | translate}}</div>
            <div *ngIf="farmersFormControls.aadharNo.errors.minlength">{{'AADHAR_NO_IS_SHOULD_BE_OF_12_DIGITS' | translate}}</div>
            <div *ngIf="farmersFormControls.aadharNo.errors.maxlength">{{'AADHAR_NO_IS_SHOULD_BE_OF_12_DIGITS' | translate}}</div>
            <div *ngIf="farmersFormControls.aadharNo.errors.pattern">{{'AADHAR_NO_SHOULD_CONTAIN_ONLY_DIGITS' | translate}}</div>
          </div>
        </div>
        <div class="field col-12 md:col-4">
          <label htmlFor="block">{{'AADHAR_PHOTO' | translate}}</label>
          <div class="flex">


            <p-fileUpload accept=".jpeg,.pdf,.jpg" #farmerAadharFileUpload [customUpload]="true" (uploadHandler)="onUpload($event, 'aadharPhotoPath', farmerAadharFileUpload)" name="myfile[]" mode="basic" [maxFileSize]="5000000" chooseLabel="{{'BROWSE' | translate}}" [auto]="true" >
            </p-fileUpload>
            <p-image *ngIf="farmersFormControls.aadharPhotoPath.value" [src]="farmersFormControls.aadharPhotoPath.value" alt="Image" width="60" class="ml-2 p-button-rounded p-button-success" iconPos="left"></p-image>

            <!-- <div class="image-background ml-2">

              <img [src] ="farmersFormControls.aadharPhotoPath.value" alt="aadhar photo" *ngIf="farmersFormControls.aadharPhotoPath.value"  class="ml-2 p-button-rounded p-button-success" iconPos="left">
            </div>
            <button *ngIf="farmersFormControls.aadharPhotoPath.value" pButton type="button" icon="pi pi-check" class="ml-2 p-button-rounded p-button-success" iconPos="left"></button> -->
          </div>
          <div *ngIf="isSubmitted && farmersFormControls.aadharPhotoPath.errors" class="invalid-feedback">
            <div *ngIf="farmersFormControls.aadharPhotoPath.errors.required">{{'AADHAR_PHOTO_IS_REQUIRED' | translate}}</div>
          </div>
        </div>
        <!-- <div class="field col-12 md:col-4"> -->
          <!-- <label htmlFor="block">PPP ID</label>
          <input formControlName="pppId" pInputText id="block" type="text"
          [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && farmersFormControls.pppId.errors }" />

          <div *ngIf="isSubmitted && farmersFormControls.pppId.errors" class="invalid-feedback">
            <div *ngIf="farmersFormControls.pppId.errors.required">PPP ID is required</div>
          </div> -->
        <!-- </div> -->
        <div class="field col-12 md:col-4">
          <label htmlFor="block">{{'PPP_ID' | translate}}</label>
          <input formControlName="pppId" pInputText id="block" type="text"
          [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && farmersFormControls.pppId.errors }" />
          <div *ngIf="isSubmitted && farmersFormControls.pppId.errors" class="invalid-feedback">
            <div *ngIf="farmersFormControls.pppId.errors.required">{{'PPP_ID_IS_REQUIRED' | translate}}</div>
            <div *ngIf="farmersFormControls.pppId.errors.minlength">{{'PPP_ID_SHOULD_BE_OF_8DIGITS' | translate}}</div>
            <div *ngIf="farmersFormControls.pppId.errors.maxlength">{{'PPP_ID_SHOULD_BE_OF_8DIGITS' | translate}}</div>
          </div>
        </div>

        <div class="field col-12 md:col-4">
          <label htmlFor="fatherName">{{'PPP_PROOF_IMAGE' | translate}}</label>
          <div class="flex">


            <p-fileUpload accept=".jpeg,.pdf,.jpg" #farmerPPPFileUpload [customUpload]="true" (uploadHandler)="onUpload($event, 'pppPhotoPath', farmerPPPFileUpload)" name="myfile[]" mode="basic" [maxFileSize]="5000000" chooseLabel="{{'BROWSE' | translate}}" [auto]="true" >
            </p-fileUpload>
            <p-image *ngIf="farmersFormControls.pppPhotoPath.value" [src]="farmersFormControls.pppPhotoPath.value" alt="Image" width="60" class="ml-2 p-button-rounded p-button-success" iconPos="left"></p-image>

            <!-- <div class="image-background ml-2">

              <img [src] ="farmersFormControls.idProofPhotoPath.value" alt="id photo" *ngIf="farmersFormControls.idProofPhotoPath.value"  class="ml-2 p-button-rounded p-button-success" iconPos="left">
            </div>

            <button *ngIf="farmersFormControls.idProofPhotoPath.value" pButton type="button" icon="pi pi-check" class="ml-2 p-button-rounded p-button-success" iconPos="left"></button> -->
          </div>
          <div *ngIf="isSubmitted && farmersFormControls.pppPhotoPath.errors" class="invalid-feedback">
            <div *ngIf="farmersFormControls.pppPhotoPath.errors.required">{{'PPP_PHOTO_IS_REQUIRED' | translate}}</div>
          </div>
        </div>


      </div>
    </form>
    <div *ngIf="!(isEditable == 0)">
      <button (click)="onFarmersFormSubmit()" pButton pRipple type="button" label="{{'SAVE' | translate}}"
        class="p-button-success mr-2 mb-2"></button>
    </div>
  </div>
</div>
